module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_5010.6038b613.png";